import { render } from "./pickAddressPopup.vue?vue&type=template&id=03d4d5b2"
import script from "./pickAddressPopup.vue?vue&type=script&lang=js"
export * from "./pickAddressPopup.vue?vue&type=script&lang=js"

import "./pickAddressPopup.vue?vue&type=style&index=0&id=03d4d5b2&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__